import { PaletteType } from '@material-ui/core';
import {
	createTheme as createMuiTheme,
	createStyles,
} from '@material-ui/core/styles';

import constants from './theme/exportedVariables.module.scss';

export function createTheme(paletteType: PaletteType) {
	return createMuiTheme({
		typography: {
			fontFamily: 'var(--font-primary, inherit)',
			button: {
				fontFamily: 'var(--font-secondary, inherit)',
			},
		},
		palette: {
			type: paletteType,
			primary: {
				main: constants.colorAsaphBlue,
				contrastText: constants.colorAsaphWhite,
				light: constants.colorBlueTint20,
			},
			secondary: {
				main: paletteType === 'light' ? '#fff' : '#36395A',
				contrastText: paletteType === 'light' ? '#23263B' : '#ffffff',
				light: paletteType === 'light' ? '#d6d6e7' : '#23263B',
			},
			success: {
				main: constants.colorGreen,
				contrastText: constants.colorAsaphWhite,
			},
			error: {
				light: constants.colorRed,
				main: constants.colorRed,
				dark: constants.colorRed,
				contrastText: constants.colorAsaphWhite,
			},
			lightBlue: {
				main: constants.colorAsaphLighterBlue,
			},
		},
		overrides: {
			MuiListItem: createStyles({
				button: {
					'&:hover': {
						backgroundColor:
							paletteType === 'light'
								? constants.colorLight1
								: constants.colorDark3,
					},
				},
			}),
			MuiPaper: createStyles({
				root: {
					'&.MuiPaper-root': {
						backgroundColor:
							paletteType === 'light'
								? constants.colorAsaphWhite
								: constants.colorDark2,
					},
				},
			}),
			MuiButtonBase: createStyles({
				root: {
					'&.MuiToggleButtonGroup-grouped': {
						backgroundColor:
							paletteType === 'light'
								? constants.colorLight1
								: constants.colorDark3,
						border: 'none',
						color:
							paletteType === 'light'
								? constants.colorDark0
								: constants.colorLight0,
						fontWeight: 500,
						lineHeight: 1.75,
						paddingBottom: '0.5rem',
						paddingLeft: '1rem',
						paddingRight: '1rem',
						paddingTop: '0.5rem',
					},
					'&.MuiToggleButtonGroup-grouped.Mui-selected': {
						backgroundColor: constants.colorAsaphBlue,
						color: constants.colorAsaphWhite,
					},
					'&.MuiToggleButtonGroup-grouped:hover': {
						backgroundColor:
							paletteType === 'light'
								? constants.colorLight2
								: constants.colorDark2,
					},
					'&.MuiToggleButtonGroup-grouped.Mui-selected:hover': {
						backgroundColor: constants.colorBlueTint20,
					},
				},
			}),
			MuiCircularProgress: createStyles({
				svg: {
					strokeLinecap: 'round',
				},
			}),
			MuiDivider: createStyles({
				root: {
					'&.MuiDivider-root': {
						backgroundColor:
							paletteType === 'light'
								? constants.colorLight0
								: constants.colorDark2,
					},
				},
			}),
		},
	});
}
